import React from 'react'
import styled from 'styled-components'
import { FaLinkedinIn, FaBehance, FaInstagram, FaAngleDown } from 'react-icons/fa'
import { FiSend } from 'react-icons/fi'
import lindy from '../assets/lindy.jpg'

const Wrapper = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 120px;
    min-height: 100vh;
    .hero__icons {
        display: flex;
        flex-direction: column;
        gap: 16px;
        grid-area: icons;
        .icons {
            font-size: 24px;
        }
    }
    .hero__content {
        grid-area: content;
        h1 {
            font-size: 30px;
            font-weight: 600;
        }
        h2 {
            font-size: 22px;
            font-weight: 500;
            margin: 12px 0;
        }
        button {
            display: flex;
            gap: 12px;
            margin-top: 30px;
            align-items: center;

            padding: 12px 16px;
            border: none;
            border-radius: 6px;
            background-color: #e2b66b;

            font-weight: 500;
            font-size: 18px;
        }
        .hero__scroll {
            display: flex;
            gap: 16px;
            position: absolute;
            top: 90vh;
            font-size: 16px;
            font-weight: 500;
            align-items: center;
            .icon {
                font-size: 24px;
            }
        }
    }
    .hero__image {
        grid-area: image;
        svg {
            width: 100%;
        }
    }

    @media (max-width: 900px) {
        display: grid;
        grid-template-areas:
        "icons image"
        "content content";
        align-items: center;
        margin-top: 30px;
        margin-bottom: 60px;
        .hero__icons {
            margin: 15px 0px;
        }
        .hero__content {
            margin-top: 30px;
            .hero__scroll {
                display: none;
                position: relative;
            }
        }
            
    }
    @media (max-width: 700px) {
        .hero__image {
            margin-left: 30px;
            svg {
                width: 80%;
            }
        }
    }
`

function Hero() {
  return (
      <Wrapper>
          <div className="hero__icons">
          <a target='_blank' rel='noreferrer' href='https://www.linkedin.com/in/lindielly-brand%C3%A3o-261a96187/'>
                    <FaLinkedinIn className="icons" />  
                </a>
                <a target='_blank' rel='noreferrer' href='https://www.behance.net/lindiellybrandao'>
                    <FaBehance className="icons" />
                </a>
                <a target='_blank' rel='noreferrer' href='https://www.instagram.com/l1ndielly/'>
                    <FaInstagram className="icons" />
                </a>
          </div>
          <div className="hero__content">
                <h1>Oi, sou a Lindielly</h1>
                <h2>Designer e Social Media</h2>
                <p>Trabalho com marketing de conteúdo<br/>para redes sociais de forma<br/>divertida e humanizada.</p>
                <button>
                    <span>Fale Comigo</span>
                    <FiSend />
                </button>
                <div className="hero__scroll">
                    <FaAngleDown className="icon" />
                    <span>Deslize para baixo</span>
                </div>
          </div>
          <div className="hero__image">
                <svg className='svgbolado' preserveAspectRatio="xMidYMid meet" viewBox="0 0 290 290" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <defs>
                        <pattern id="pattern0" height="1" width="1">
                            <image height="100%" href={lindy}></image>
                        </pattern>
                    </defs>
                    <g fill='url(#pattern0)'>
                        <path d="M248 110C264.708 185.343 266.579 221.639 229.389 258.564C191.93 295.49 105.086 305.188 55.5 258.564C5.9135 211.941 -8.74404 194.875 5.00004 125.5C18.7441 56.1246 75.1477 -3.89454 131.741 0.208304C188.065 4.31115 231.292 35.0298 248 110Z"/>
                    </g>
                </svg>
          </div>
      </Wrapper>
  );
}

export default Hero;